import { Col, Row } from 'antd';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { IoIosArrowBack } from 'react-icons/io';
import { categoryIconMapping } from 'utils/category';

import Button, { ToggleFavouriteButton } from 'components/Buttons';
import Title from 'components/Title';
import useDocumentDetails from 'hooks/useDocumentDetails';
import { CATEGORY_TYPE } from 'models/documents.model';
import { COLOR } from 'styles/styledComponents/color.model';

import { BasicCard } from '../../../../components/BasicCard';
import * as Styled from './Template.styles';

interface TypeTemplateProps {
  type: CATEGORY_TYPE;
  batchCard: ReactNode;
  detailsCard: ReactNode;
  children: ReactNode;
  jobId: string;
  favourite: boolean;
}

const Template = ({
  type,
  batchCard,
  detailsCard,
  children,
  jobId,
  favourite,
}: TypeTemplateProps) => {
  const { t } = useTranslation();
  const { onBack } = useDocumentDetails();

  return (
    <>
      <Row justify="space-between">
        <Button type="text" $uppercase icon={<IoIosArrowBack />} onClick={onBack}>
          {t('nav.back')}
        </Button>

        <Styled.CategoryIcons>
          {categoryIconMapping.map(({ Icon, category }) => (
            <Icon
              key={category}
              width="44"
              className={type === category ? 'Active' : undefined}
              color={type === category ? COLOR.BATTERY_CELLS : COLOR.LAVENDER_GRAY}
            />
          ))}
        </Styled.CategoryIcons>
      </Row>

      <Row justify="space-between">
        <Title padding="1rem 0">{`${t(`certificate.${type}`)} ${t('document.certificate')}`}</Title>

        <ToggleFavouriteButton hasDarkOutline isClickable jobId={jobId} isFavourite={favourite}>
          {favourite ? t('certificate.removeFromFavourites') : t('certificate.addToFavourites')}
        </ToggleFavouriteButton>
      </Row>

      <Row gutter={[16, 16]}>
        <Col md={24} lg={10}>
          <BasicCard $height="100%">{batchCard}</BasicCard>
        </Col>
        <Col md={24} lg={14}>
          <BasicCard $height="100%">{detailsCard}</BasicCard>
        </Col>
      </Row>

      {children}
    </>
  );
};

export default Template;
